export default __webpack_public_path__ + "static/media/angolo-v2-dark.b8e43fd4.svg";